import AccountVerify from './AccountVerify.component';
import AccountVerificationModal from './AccountVerificationModal.component';

export default {
	AccountVerify,
	AccountVerificationModal,
};
